// MyFavorites

export const GET_MY_FAVORITES = 'GET_MY_FAVORITES';
export const SUCESS_GET_MY_FAVORITES = 'SUCESS_GET_MY_FAVORITES';
export const ERROR_GET_MY_FAVORITES = 'ERROR_GET_MY_FAVORITES';

export const DELETE_FAVORITE = 'DELETE_FAVORITE';
export const SUCESS_DELETE_FAVORITE = 'SUCESS_DELETE_FAVORITE';
export const ERROR_DELETE_FAVORITE = 'ERROR_DELETE_FAVORITE';
